/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
// @ts-ignore
import whiteLogo from "../../src/assets/img/logo.png";
import { PrivateLayoutProps } from "../types/global";

export const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children }) => {
  return (
    <div className="cardWhite">
      <div className="row main-login-row h-screen">
        <div className="col-lg-7 col-sm-12 p-0">
          <div className="sidebanner flex flex-col justify-between ps-[100px] pt-40 pb-[60px] 3xl:pb-[90px]">
            <div className="mainLogsContined">
              <div className="whitelogos relative z-[1]">
                <img
                  src={whiteLogo}
                  alt="logo"
                  className="h-[192px] w-[172px]"
                />
              </div>
            </div>

            <div className="authSidetext w-100">
              <h2 className="text-white  text-[50px] 2xl:text-[60px] relative z-[1] font-medium mb-[14px] leading-[60px] 2xl:leading-[76px]">
                Superior Service <br /> & Support
              </h2>
              <h5 className="relative z-[1] text-white text-[18px] 2xl:text-[24px] font-normal max-w-[550px]">
                The Global Leader In Advanced Aircraft Propeller Design And
                Manufacturing Technology{" "}
              </h5>
            </div>
          </div>
        </div>
        <div className="col-lg-5 col-sm-12 p-0 login-right-col">{children}</div>
      </div>
    </div>
  );
};
